import Confirmation from "../components/Confirmation";
import closed from "../assets/closed.svg";

function ListClosed() {
  return (
    <Confirmation
      title={"List Closed!"}
      picture={closed}
      firstButtonText={"See Final Standings"}
    />
  );
}

export default ListClosed;
